import React from "react";
import { Link, Route, Routes, useLocation } from "react-router-dom";
import RightFixed from "../RightFixed/RightFixed";
import "./MySaved.css";
import { IoShareOutline } from "react-icons/io5";
import { FiMoreHorizontal } from "react-icons/fi";
import EachSaved from "./EachSaved";

export default function MySaved({ ownSaved }) {
  return (
    <div className="my-saved">
      <div className="bosh-container">
        <div className="header-flex">
          <h1>Your Stories</h1>

          <div className="btns-flex1">
            <Link to="../new-story">
              <button className="write-story">Write a Story</button>
              <button className="import-story">Import a story</button>
            </Link>
          </div>
        </div>

        <div className="drafts">
          <button>Drafts 1</button>
          <button className="active">Published 1</button>
          <button>Response 1</button>
        </div>

        <ul className="save-ul2">
          {ownSaved.map((item, i) => {
            console.log(item.id);
            return (
              <Link key={i} className="aa" to={`${item.id}`}>
                <li className="save-li2">
                  <h3>{item.decs}</h3>
                  <div className="li-bottom">
                    <p className="publish-p">
                      Published {item.data}, {item.read} 1 minute read{" "}
                      <span>
                        <IoShareOutline /> <FiMoreHorizontal />
                      </span>
                    </p>
                  </div>
                </li>
              </Link>
            );
          })}
        </ul>
      </div>

      <div className="fix-div">
        <RightFixed />
      </div>
    </div>
  );
}
